<div id="module-cards-list" fxLayout="row wrap" fxLayoutAlign="start">
    <span id="ruler-2" class="ruler"></span>
    <div class="w-100-p" *ngIf="dataSource">
        <mat-table #table [dataSource]="dataSource" matSort>
            <!-- Avatar Column -->
            <ng-container matColumnDef="avatar">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let module" class="avatar-cell">
                    <div #avatarCell *ngIf="module.image; else noModuleImage">
                        <img
                            class="avatar pointer"
                            [class.square]="module.kind === ModuleKind.ProgramExecution"
                            [ngStyle]="module.kind === ModuleKind.ProgramExecution && { width: '72px' }"
                            [alt]="module.name"
                            [src]="module.image.thumbUrl"
                        />
                    </div>
                    <ng-template #noModuleImage>
                        <div #avatarCell>
                            <div class="avatar pointer module-icon-container no-image">
                                <mat-icon class="bg-icon" svgIcon="bg_illustration"></mat-icon>
                            </div>
                        </div>
                    </ng-template>
                </mat-cell>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="name">
                <mat-header-cell class="pl-24 cell-30" *matHeaderCellDef mat-sort-header>{{ 'GENERAL.PROPERTY.NAME' | translate }}</mat-header-cell>
                <mat-cell #nameCell *matCellDef="let module" class="pl-24 cell-30" fxLayout="column" fxLayoutAlign="center stretch">
                    <div fxLayout="row" fxLayoutAlign="start center" class="name-with-type-icon w-100-p min-w-0">
                        <mat-icon class="icon-18 mr-8 shrink-0" [svgIcon]="module | getModuleIcon"></mat-icon>
                        <a (click)="goToModule(module)" class="text-truncate font-semibold pointer min-w-0" [tooltipIfTruncated]="module.name">{{ module.name }}</a>
                    </div>
                    <div fxLayoutAlign="start center" *ngIf="module.tags.length">
                        <mat-chip-set #chipList class="mr-8 py-8">
                            <mat-chip
                                *ngFor="let tag of module.tags | filterTags: nameCell:this"
                                (click)="filterByTag(tag)"
                                class="pointer"
                                [style.background]="tag.color"
                                [disableRipple]="true"
                            >
                                {{ tag.name }}
                            </mat-chip>
                        </mat-chip-set>
                        <ng-container *ngIf="chipList._chips && chipList._chips.length < module.tags.length">
                            <div #more class="more-tags">...</div>
                            <app-tags-card [tags]="module.tags" [target]="more" (clickedTag)="filterByTag($event)"> </app-tags-card>
                        </ng-container>
                    </div>
                </mat-cell>
            </ng-container>

            <!-- Start Date Column -->
            <ng-container matColumnDef="startDate">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.gt-sm>{{ 'GENERAL.PROPERTY.START_DATE' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let module" fxHide fxShow.gt-sm>
                    <p class="text-truncate">
                        {{ module.startDate | date: 'shortDate' }}
                    </p>
                </mat-cell>
            </ng-container>

            <!-- End Date Column -->
            <ng-container matColumnDef="endDate">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.gt-sm>{{ 'GENERAL.PROPERTY.END_DATE' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let module" fxHide fxShow.gt-sm>
                    <p class="text-truncate">
                        {{ module.endDate | date: 'shortDate' }}
                    </p>
                </mat-cell>
            </ng-container>

            <!-- Status column -->
            <ng-container matColumnDef="status">
                <mat-header-cell *matHeaderCellDef class="status">{{ 'GENERAL.PROPERTY.STATUS' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let module" class="status">
                    <p class="text-truncate">
                        {{ module.status | getStatus: moduleStatuses:'translationLabel' | translate }}
                    </p>
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let audienceUser; columns: displayedColumns" class="user" matRipple> </mat-row>
        </mat-table>
    </div>
</div>
